module.exports = __webpack_public_path__ + "img/RHB Bank.74200600.png";